import {
	getcanteentree,
	getDingcanRole,
	editDingcanRole,
	getLabel,
	addLabel,
	putLabel,
	delLabel,
	mealLineCaiDown,
	mealLineDown,
	getAreaTree,
	getArea,
	delArea,
	editArea,
	addArea,
	getCanteenStallTree
} from '@/api/canteendangkou'
import { canteenList, stallList } from '@/api/enumerate'
// import { getToken } from '@/utils/auth'
const state = {}
const mutations = {}

const actions = {
	addArea ({}, data) {
		return new Promise((resolve, reject) => {
			addArea(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	editArea ({}, data) {
		return new Promise((resolve, reject) => {
			editArea(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delArea ({}, data) {
		return new Promise((resolve, reject) => {
			delArea(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getArea ({}, data) {
		return new Promise((resolve, reject) => {
			getArea(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getAreaTree ({}, data) {
		return new Promise((resolve, reject) => {
			getAreaTree(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getDingcanRole ({}, data) {
		return new Promise((resolve, reject) => {
			getDingcanRole(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	editDingcanRole ({}, data) {
		return new Promise((resolve, reject) => {
			editDingcanRole(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getcanteen ({}, data) {
		return new Promise((resolve, reject) => {
			canteenList(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getcanteentree ({}, data) {
		return new Promise((resolve, reject) => {
			getcanteentree(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	getstalls ({}, data) {
		return new Promise((resolve, reject) => {
			stallList(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getLabel ({}, data) {
		return new Promise((resolve, reject) => {
			getLabel(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addLabel ({}, data) {
		return new Promise((resolve, reject) => {
			addLabel(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	putLabel ({}, data) {
		return new Promise((resolve, reject) => {
			putLabel(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	delLabel ({}, data) {
		return new Promise((resolve, reject) => {
			delLabel(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	mealLineCaiDown ({}, data) {
		return new Promise((resolve, reject) => {
			mealLineCaiDown(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	mealLineDown ({}, data) {
		return new Promise((resolve, reject) => {
			mealLineDown(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getCanteenStallTree ({}, data) {
		return new Promise((resolve, reject) => {
			getCanteenStallTree(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
